import { Fragment } from 'react';
import styled from '@emotion/styled/macro';
import { Stat, StatLabel, StatNumber, StatHelpText, HStack, VStack, Box, StackDivider, Text } from '@chakra-ui/react';

const DashboardStats = ({ stats }) => {
    return (
        <>
            <StatsWrapper spacing={6}>
                {stats.map(({ isLabelVisible, label, isValueCritical, value, description, hasDivider }, index) => (
                    <Fragment key={index}>
                        <Box>
                            <Stat>
                                <StatLabelWrapper>
                                    <Text size="sm" opacity={isLabelVisible ? 1 : 0}>
                                        {label}
                                    </Text>
                                </StatLabelWrapper>

                                <StatNumber mt={2}>
                                    <StatNumberWrapper critical={isValueCritical}>{value}</StatNumberWrapper>
                                </StatNumber>

                                <StatHelpTextWrapper mb={0}>{description}</StatHelpTextWrapper>
                            </Stat>
                        </Box>

                        {hasDivider && <StackDivider width="1px" bgColor="gray.100" />}
                    </Fragment>
                ))}
            </StatsWrapper>

            <MobileStatsWrapper spacing={5} align="stretch">
                {stats.map(({ isLabelVisible, label, isValueCritical, value, description }, index) => (
                    <Box key={index}>
                        <Stat>
                            {isLabelVisible ? (
                                <StatLabelWrapper>
                                    <Text size="sm">{label}</Text>
                                </StatLabelWrapper>
                            ) : null}

                            <StatNumber mt={2} fontSize={{ base: '18px' }}>
                                <StatNumberWrapper critical={isValueCritical}>{value}</StatNumberWrapper>
                            </StatNumber>

                            <StatHelpTextWrapper mb={0}>{description}</StatHelpTextWrapper>
                        </Stat>
                    </Box>
                ))}
            </MobileStatsWrapper>
        </>
    );
};

const StatsWrapper = styled(HStack)`
    @media screen and (max-width: 375px) {
        display: none;
    }
`;

const MobileStatsWrapper = styled(VStack)`
    @media screen and (min-width: 376px) {
        display: none;
    }
`;

const StatLabelWrapper = styled(StatLabel)`
    color: var(--chakra-colors-gray-600);
`;

const StatNumberWrapper = styled.div`
    color: ${(props) => (props.critical ? 'var(--chakra-colors-gray-800)' : 'var(--chakra-colors-gray-800)')};
`;

const StatHelpTextWrapper = styled(StatHelpText)`
    color: var(--chakra-colors-gray-900);
`;

export default DashboardStats;
